/**
 * KHIYARSA (Phase 2): jotai state for the cloud layer.
 */
import { atom } from "../../app-jotai";

import type { CloudUser } from "./api";

export type SyncStatus = "idle" | "synced" | "saving" | "offline" | "conflict";

export interface AttachedProject {
  projectId: string;
  title: string;
  /** server content_revision our canvas is based on */
  revision: number;
  /** getSceneVersion() at last successful sync with the server */
  sceneVersion: number | null;
}

export interface CloudConflict {
  serverRevision: number;
  serverUpdatedAt: string;
}

/** null = signed out; undefined = not yet determined (startup) */
export const cloudUserAtom = atom<CloudUser | null | undefined>(undefined);

export const attachedProjectAtom = atom<AttachedProject | null>(null);

export const syncStatusAtom = atom<SyncStatus>("idle");

export const cloudConflictAtom = atom<CloudConflict | null>(null);

/** Conflict dialog was closed without resolving — banner remains as re-entry. */
export const conflictDialogDismissedAtom = atom(false);

export type CloudDialogState =
  | { type: "none" }
  | { type: "auth" }
  | { type: "projects" }
  | { type: "saveAs" }
  | { type: "revisions"; projectId: string; projectTitle: string };

export const cloudDialogAtom = atom<CloudDialogState>({ type: "none" });
